import { Alert, Button, PageHeader, TextField } from "@emdur/ui";
import { useEffect, useState } from "react";
import { publicCall } from "../lib/api";
import { startSignIn } from "../lib/auth";
import { errorText } from "../lib/errors";
import * as passkeys from "../lib/passkeys";

type Inspection = { organization: { display_name: string }; roles: { name: string }[]; email_hint: string; ceremony: "registration" | "authentication" };

export function Invitation() {
  const token = new URLSearchParams(location.hash.slice(1)).get("token") ?? "";
  const [inspection, setInspection] = useState<Inspection | null>(null);
  const [name, setName] = useState("");
  const [done, setDone] = useState(false);
  const [error, setError] = useState<unknown>(null);

  useEffect(() => {
    publicCall("POST", "/v1/invitations/inspect", { invitation_token: token })
      .then(async (r) => (r.ok ? setInspection((await r.json()) as Inspection) : setError(new Error("This invitation has expired, been used or been revoked."))))
      .catch(setError);
  }, [token]);

  async function accept() {
    try {
      const started = await publicCall("POST", "/v1/invitation-acceptances", { invitation_token: token });
      if (!started.ok) throw new Error(`could not start (${started.status})`);
      const { id, ceremony, public_key } = await started.json();
      const credential = ceremony === "registration" ? await passkeys.create(public_key) : await passkeys.get(public_key);
      const body = ceremony === "registration" ? { credential, display_name: name } : { credential };
      const completed = await publicCall("POST", `/v1/invitation-acceptances/${id}/complete`, body);
      if (!completed.ok) throw new Error(`not accepted (${completed.status})`);
      history.replaceState(null, "", "/invitations"); // drop the token from the address bar
      setDone(true);
    } catch (e) {
      setError(e);
    }
  }

  if (done)
    return (
      <>
        <PageHeader title="You're in" description="Your passkey is set up." />
        <Button variant="primary" onPress={() => void startSignIn("/")}>
          Sign in
        </Button>
      </>
    );
  if (!inspection) return error ? <Alert tone="danger">{errorText(error)}</Alert> : null;
  const registration = inspection.ceremony === "registration";
  return (
    <>
      <PageHeader
        title={`Join ${inspection.organization.display_name}`}
        description={`Invitation for ${inspection.email_hint} as ${inspection.roles.map((r) => r.name).join(", ")}.`}
      />
      <div className="flex flex-col gap-4">
        {registration && <TextField label="Your name" value={name} onChange={setName} isRequired />}
        <div>
          <Button variant="primary" onPress={() => void accept()} isDisabled={registration && !name.trim()}>
            {registration ? "Create passkey and join" : "Use my passkey and join"}
          </Button>
        </div>
        {error !== null && <Alert tone="danger">{errorText(error)}</Alert>}
      </div>
    </>
  );
}
